import { MessageCircle, Phone, MapPin } from "lucide-react";
import { waLink, WA_MESSAGES, PHONE_TEL, DIRECTIONS_URL } from "@/config/site";

const FloatingContact = () => (
    <>
        <a
            href={waLink(WA_MESSAGES.general)}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-floating-btn"
            aria-label="Chat on WhatsApp"
            className="hidden md:flex fixed bottom-8 right-8 z-[70] w-14 h-14 rounded-full bg-gold text-obsidian items-center justify-center wa-pulse hover:scale-110 transition-transform duration-300 shadow-lg shadow-gold/20"
        >
            <MessageCircle size={24} strokeWidth={1.75} />
        </a>
        <div
            className="md:hidden fixed bottom-0 inset-x-0 z-[70] grid grid-cols-3 bg-charcoal/95 backdrop-blur-md border-t border-gold/25"
            data-testid="mobile-sticky-bar"
        >
            <a
                href={waLink(WA_MESSAGES.general)}
                target="_blank"
                rel="noreferrer"
                data-testid="sticky-whatsapp"
                className="flex flex-col items-center gap-1 py-3 text-gold"
            >
                <MessageCircle size={19} strokeWidth={1.5} />
                <span className="text-[10px] tracking-[0.2em] uppercase">WhatsApp</span>
            </a>
            <a
                href={`tel:${PHONE_TEL}`}
                data-testid="sticky-call"
                className="flex flex-col items-center gap-1 py-3 text-ivory/85 border-x border-gold/15"
            >
                <Phone size={19} strokeWidth={1.5} />
                <span className="text-[10px] tracking-[0.2em] uppercase">Call</span>
            </a>
            <a
                href={DIRECTIONS_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="sticky-directions"
                className="flex flex-col items-center gap-1 py-3 text-ivory/85"
            >
                <MapPin size={19} strokeWidth={1.5} />
                <span className="text-[10px] tracking-[0.2em] uppercase">Directions</span>
            </a>
        </div>
    </>
);

export default FloatingContact;
